import { gql } from 'graphql-request'

export const FETCH_REGIONAL_CITIZENSHIPS = gql`
  query regionalCitizenships($candidateProfileId: ID!) {
    regionalCitizenships(candidateProfileId: $candidateProfileId) {
      id
      citizenshipStatus
      permitType
      countryName
      countryIso2Code
      description
      requiresSponsorship
      attachments {
        id
        file {
          name
          url
        }
      }
    }
  }
`

export const UPDATE_REGIONAL_CITIZENSHIP = gql`
  mutation ($input: UpdateCandidateRegionalCitizenshipInput!) {
    updateCandidateRegionalCitizenship(input: $input) {
      regionalCitizenship {
        id
        citizenshipStatus
        permitType
        countryName
        countryIso2Code
        description
        attachments {
          id
          file {
            name
            url
          }
        }
      }
    }
  }
`

export const CREATE_REGIONAL_CITIZENSHIP_ATTACHMENT = gql`
  mutation ($input: CreateAttachmentInput!) {
    createAttachment(input: $input) {
      attachment {
        id
        file {
          name
          url
        }
      }
    }
  }
`

export const DELETE_REGIONAL_CITIZENSHIP_ATTACHMENT = gql`
  mutation ($input: DeleteAttachmentInput!) {
    deleteAttachment(input: $input) {
      attachment {
        id
        file {
          name
          url
        }
      }
    }
  }
`

export const FETCH_REMOTE_POLICIES = gql`
  query ($candidateProfileId: ID!) {
    candidateProfile(id: $candidateProfileId) {
      remotePolicies {
        id
        type
        cities {
          id
          name
          countryName
        }
        comprehensiveLocations {
          inputtedAddress
        }
      }
    }
  }
`

export const UPDATE_REMOTE_POLICIES = gql`
  mutation updateRemotePolicies($input: UpdateCandidateProfileInput!) {
    updateCandidateProfile(input: $input) {
      candidateProfile {
        id
        name
        remotePolicies {
          id
          type
          comprehensiveLocations {
            inputtedAddress
          }
        }
      }
    }
  }
`
